module.exports = __webpack_public_path__ + "static/media/lexin_bg.fbf9ff37.png";